/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationForThreatsGcp extends models.GovernanceConfigurationBaseForThreats {
    constructor() {
        super();
        this.setDiscriminator("GovernanceConfigurationForThreatsGcp");
    }

    getFixupPrototypeFunction() { return GovernanceConfigurationForThreatsGcp.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationForThreatsGcp>): GovernanceConfigurationForThreatsGcp {
        let obj = Object.assign(new GovernanceConfigurationForThreatsGcp(), model);
        GovernanceConfigurationForThreatsGcp.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationForThreatsGcp>): GovernanceConfigurationForThreatsGcp {
        if (!model) return null;
        return GovernanceConfigurationForThreatsGcp.newInstance(<GovernanceConfigurationForThreatsGcp> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationForThreatsGcp) {
        if (!obj) return;

        models.GovernanceConfigurationForThreatsGcp.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationForThreatsGcp): boolean {
        if (models.GovernanceConfigurationBaseForThreats.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationForThreatsGcp.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Specifies whether Event Threat Detection enabled or not
     */
    event_threat_detection: boolean;

    /**
     * Specifies whether Container Threat Detection enabled or not
     */
    container_threat_detection: boolean;

}
